import { gql, TypedDocumentNode } from '@apollo/client';

/* TIS GraphQL Queries */
export type ListUserAccessesByUserIdVars = {
  userId: string;
};

export type ListUserAccessesByUserId = {
  listUserAccessesByUserId?: {
    __typename: 'ModelUserAccessConnection';
    nextToken?: string | null;
    items?:
      | {
          id?: string;
          userId?: string;
          appId?: string;
          roleId?: string;
        }[]
      | null;
  } | null;
};

export const listUserAccessesByUserId = gql`
  query ListUserAccessesByUserId($userId: ID!) {
    listUserAccessesByUserId(userId: $userId) {
      items {
        id
        userId
        appId
      }
    }
  }
` as TypedDocumentNode<ListUserAccessesByUserId, ListUserAccessesByUserIdVars>;
